import { Component, OnInit } from '@angular/core';
import { Router, RouteConfigLoadStart, RouteConfigLoadEnd, RouterOutlet } from '@angular/router';
import { VideoComponent } from '../../../shared/video/video.component';
import { FooterComponent } from '../footer/footer.component';
import { ContentAnimateDirective } from '../../../core/content-animate/content-animate.directive';
import { NavbarComponent } from '../navbar/navbar.component';
import { SidebarComponent } from '../sidebar/sidebar.component';

@Component({
    selector: 'app-base',
    templateUrl: './base.component.html',
    styleUrls: ['./base.component.scss'],
    imports: [
        SidebarComponent,
        NavbarComponent,
        ContentAnimateDirective,
        RouterOutlet,
        FooterComponent,
        VideoComponent,
    ]
})
export class BaseComponent implements OnInit {
  isLoading: boolean;

  constructor(private router: Router) {
    // Spinner for lazyload modules
    router.events.forEach((event) => {
      if (event instanceof RouteConfigLoadStart) {
        this.isLoading = true;
      } else if (event instanceof RouteConfigLoadEnd) {
        this.isLoading = false;
      }
    });
  }

  ngOnInit(): void {}
}
